import { getVacancyByStatus } from '../../../actions/vacancies';
import { store } from '../../../index';

export function* onChangeVacancyStatus() {
  const { dispatch } = store;
  dispatch(getVacancyByStatus(() => {}));
  yield true;
}
